module.exports = __webpack_public_path__ + "static/media/name.2ab8692f.svg";